import React, { Component } from "react";
import Navigation from "./Navigation";
import MoviesList from "./MoviesList";
import Breaker from "./Breaker";
import Foot from "./Foot";
import Pagination from "./Pagination";
import SEO from "./SEO";
const config = require("../config");

class MainContainer extends Component {
    componentDidMount() {
        const { titleChange } = this.props;
        titleChange(`Home`);
    }

    render() {
        const {
            favorites,
            movies,
            upcomingMovies,
            favoriteEvent,
            onSearch,
            totalFavorites,
            totalWatched,
            searchKeyUpdate,
            props,
            totalPages,
            currentPage,
            onPageChange,
            watchedToggle,
            watched
        } = this.props;

        const seoTagForFrontPage = {
            title: config.siteName,
            description:
                "A website to track and collect your favorite and watched movies."
        };

        return (
            <div>
                <SEO generateFrom={seoTagForFrontPage} />
                <Navigation
                    onSearch={onSearch}
                    totalFavorites={totalFavorites}
                    searchKeyUpdate={searchKeyUpdate}
                    totalWatched={totalWatched}
                />

                <div className="container">
                    <Breaker
                        title="Upcoming Movies"
                        hidden={
                            upcomingMovies && upcomingMovies.length > 0
                                ? false
                                : true
                        }
                    />

                    <MoviesList
                        {...props}
                        movies={upcomingMovies.slice(0, 5)}
                        favorites={favorites}
                        updateFavorites={favoriteEvent}
                        totalPages={totalPages}
                        currentPage={currentPage}
                        onPageChange={onPageChange}
                        watchedToggle={watchedToggle}
                        watched={watched}
                    />

                    <Breaker
                        title="Sorted by popularity"
                        hidden={upcomingMovies ? false : true}
                    />

                    <MoviesList
                        {...props}
                        movies={movies}
                        favorites={favorites}
                        updateFavorites={favoriteEvent}
                        totalPages={totalPages}
                        currentPage={currentPage}
                        onPageChange={onPageChange}
                        watchedToggle={watchedToggle}
                        watched={watched}
                    />

                    <Pagination
                        totalPages={totalPages}
                        currentPage={currentPage}
                        onPageChange={onPageChange}
                    />

                    <Foot />
                </div>
            </div>
        );
    }
}

export default MainContainer;



// WEBPACK FOOTER //
// ./src/components/MainContainer.js